/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgExtendFact = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M15 2h7v7h-2V5.414l-3.293 3.293-1.414-1.414L18.586 4H15zm-8.617 9 .456-4.11 1.988.22L8.395 11h2.988l.456-4.11 1.988.22-.432 3.89H17v2h-3.827l-.333 3H17v2h-4.383l-.456 4.11-1.988-.22.432-3.89H7.617l-.456 4.11-1.988-.22.432-3.89H2v-2h3.827l.334-3H2v-2zm1.79 2-.334 3h2.988l.333-3z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgExtendFact as ExtendFact };
